import { compose } from '../helpers';
import {
  changeMixin,
  inputEventsDispatchingMixin,
  inputValidationMixin,
  normalizeBooleanAttributesMixin,
} from '../mixins';
import { createBaseClass } from './createBaseClass';

export const createBaseInputClass = (...args) =>
  compose(
    inputValidationMixin,
    changeMixin,
    normalizeBooleanAttributesMixin,
    inputEventsDispatchingMixin
  )(createBaseClass(...args));
